import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"

// cardPaymentBrick docs: https://github.com/mercadopago/sdk-js/blob/main/docs/bricks/card-payment.md
export default class extends Controller {

  static values = {
    publicKey: String,
    amount: Number,
    payerEmail: String,

    processingUrl: String,
    resolvedUrl: String,

    fallbackUrl: String,

    submitText: String,

    locale: String
  }

  static targets = ["errorContainer", "errorText", "fallbackContainer", "placeholder"]

  connect() {
    Loggable(this, {debug: false})

    const mp = new MercadoPago(this.publicKeyValue, {
      locale: this.localeValue
    });
    const bricksBuilder = mp.bricks();

    this.renderCardPaymentBrick(bricksBuilder);
    this.log("connected")
  }


  async renderCardPaymentBrick(bricksBuilder) {
    // podría inicializar el form con datos del usuario: https://www.mercadopago.com.ar/developers/es/docs/checkout-bricks/card-payment-brick/advanced-features/initialize-data-on-the-bricks
    const settings = {
      initialization: {
        amount: this.amountValue, // monto total a pagar
        payer: {
          email: this.payerEmailValue
        }
      },
      customization: {
        paymentMethods: {
          minInstallments: 1,
          maxInstallments: 1,
        },
        visual: {
          style: {
            // see customization options: https://www.mercadopago.com.ar/developers/es/live-demo/card-payment-brick
            theme: this.styleTheme(),
            customVariables: this.customStyleVariables()
          },
          texts: {
            formSubmit: this.submitTextValue,
          }
        }
      },
      callbacks: {
        onReady: () => {
          this.element.classList.remove("d-none")
        },
        onSubmit: (formData) => {
          formData.format = "json" // force json response

          // callback llamado al hacer clic en el botón enviar datos
          return new Promise((resolve, reject) => {
            this.hideError()
            fetch(this.processingUrlValue, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                console.log("backend response:", response)
                if (response.id) {
                  // recibir el resultado del pago
                  resolve();
                   Turbo.visit(this.resolvedUrlValue)
                } else {
                  // hubo un error en el pago
                  try {
                    console.error(response.message)
                    let errorCode = response.message.cause[0].code
                    this.showError(`Error al procesar el pago (${errorCode})`)
                  } catch(e) {
                    this.showError(`Error al procesar el pago: ${response.message}`)
                  }
                  reject();
                }
              })
              .catch((error) => {
                // hubo un error inesperado
                console.log("calling reject", error)
                alert("Error al procesar el pago (500)")
                reject();
              });
          });
        },
        onError: ({type, message}) => {
          if (type === "critical") {
            this.showFallback()
          }
          console.error("[Brick error]", message);
        },
      },
    };
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("d-none")
    }
    window.cardPaymentBrickController = await bricksBuilder.create(
      'cardPayment',
      'cardPaymentBrick_container',
      settings,
    );
  };

  styleTheme(){
    const currentTheme = document.querySelector("html").dataset.bsTheme // 'light' or 'dark'. see app/javascript/controllers/color_scheme_switcher_controller.js
    switch (currentTheme) {
      case 'dark':
        return 'dark'
      case 'light':
        return 'bootstrap'
      default:
        return 'bootstrap'
    }
  }

  customStyleVariables(){
    const bgColor = getComputedStyle(this.element.parentElement).backgroundColor
    return {
      formBackgroundColor: bgColor
    }
  }

  showFallback(){
    if (this.hasFallbackContainerTarget && this.fallbackUrlValue !== "") {
      this.fallbackContainerTarget.classList.remove("d-none")
    }
  }

  hideError() {
    this.errorContainerTarget.classList.remove("show")
  }

  showError(message) {
    this.errorTextTarget.innerHTML = message
    this.errorContainerTarget.classList.add("show")
  }

  disconnect() {
    window.cardPaymentBrickController.unmount()
  }
}
